import { MODULE as PARENT } from '../constants'

export const KEY = 'menu'
export const MODULE = [...[PARENT], KEY]
